import { render } from "./ArtifactOwnList.vue?vue&type=template&id=9dcf17ca&scoped=true&ts=true"
import script from "./ArtifactOwnList.vue?vue&type=script&lang=ts"
export * from "./ArtifactOwnList.vue?vue&type=script&lang=ts"

import "./ArtifactOwnList.vue?vue&type=style&index=0&id=9dcf17ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dcf17ca"]])

export default __exports__